import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { FormErrorMessage } from "@/components/ui/FormErrorMessage";
import { Input } from "@/components/ui/input";
import type { EditTitleVisitSchemaType } from "@/schemas/editTitleVisit.schema";
import { t } from "i18next";
import { useFormContext } from "react-hook-form";

interface EditTitleVisitDialogFormProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  loading: boolean;
  onSubmit: (data: EditTitleVisitSchemaType) => void;
}

export const EditTitleVisitDialogForm = (
  props: EditTitleVisitDialogFormProps
): JSX.Element => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useFormContext<EditTitleVisitSchemaType>();

  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("visit.updateTitle")}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit(props.onSubmit)}>
          <div className="py-4">
            <Input
              {...register("title")}
              className="w-full border p-2"
              type="text"
            />
            <FormErrorMessage content={errors.title?.message} />
          </div>
          <DialogFooter>
            <Button disabled={props.loading} type="submit">
              {t("common.save")}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
